import CONSTANTS from "src/utils/constants";
import JEPlaceholder from "src/models/je-allocation/JEPlaceholder";

const JEAllocationUtils = {
    convertToPlaceholdersMap(jePlaceholders: JEPlaceholder[]): Map<string, JEPlaceholder[]> {
        const result = new Map<string, JEPlaceholder[]>();
        Object.values(CONSTANTS.COA_SEGMENT_MAPPING).forEach(x => {
            const segmentJEPlaceholders = jePlaceholders.filter(y => y.coaSegment == x.UI)
                .sort((a, b) => (a.sequence != null ? a.sequence : 0) - (b.sequence != null ? b.sequence : 0));
            if (segmentJEPlaceholders.length > 0) {
                result.set(x.UI, segmentJEPlaceholders);
            }
        });
        return result;
    }
}

export default JEAllocationUtils
